import React from 'react';
import Loader from 'react-loader-spinner';
import './style.scss';

const CarouselLoader = () => {
  return (
    <div className="carousel-loader">
      <Loader type="Oval" color="#8A0101" height={60} width={60} />
    </div>
  );
};

export default CarouselLoader;
